export enum ApiEmpresaSituacao {
	Aprovada = 1,
	Pendente = 2,
	Bloqueada = 3,
}
